import * as React from 'react';

const LaughingFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M19.373 18.912a2.313 2.313 0 1 1-4.626 0 2.313 2.313 0 0 1 4.627 0Zm13.88 0a2.313 2.313 0 1 1-4.626 0 2.313 2.313 0 0 1 4.626 0m-19.013 7.54c-1.446 0-2.73 1.487-1.933 3.05 1.192 2.34 4.464 6.853 11.693 6.853s10.5-4.513 11.693-6.852c.797-1.564-.487-3.05-1.933-3.05zM24 33.854c-5.363 0-7.983-2.951-9.143-4.902h18.286c-1.16 1.95-3.78 4.902-9.143 4.902"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M43.001 24.001c0 10.494-8.507 19.001-19.001 19.001S4.999 34.495 4.999 24.001 13.506 5 24 5s19.001 8.507 19.001 19.001M24 40.502c9.113 0 16.501-7.388 16.501-16.501S33.113 7.5 24 7.5 7.499 14.888 7.499 24.001 14.887 40.502 24 40.502"
  }
));
LaughingFace48.Size = 48;
LaughingFace48.Title = "LaughingFace";

export { LaughingFace48 as default };
